import { render, staticRenderFns } from "./RsManagement.vue?vue&type=template&id=77fdd814&scoped=true&"
import script from "./RsManagement.vue?vue&type=script&lang=js&"
export * from "./RsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fdd814",
  null
  
)

export default component.exports